$(document).ready(function () {
    $("body").off("change", "#" + xomDropdownListConfig.modelValueId);

    $("body").on("change", "#" + xomDropdownListConfig.modelValueId, function () {
        var bindingContorlIds = xomDropdownListConfig.bindingControlIds.split(',');
        var dependentsArr = [];

        var idVal = xomDropdownListConfig.modelValueId.split("_")[1];
        console.log(idVal);
        bindingContorlIds.forEach(el => {
            var hiddenField = $("[data-sc-field-name='" + el + "']");
            console.log(hiddenField);
            var datasource = $(hiddenField).attr('data-source');
            dependentsArr.push({ "fname": el, "fvalue": datasource });
        });
        var obj = {
            name: xomDropdownListConfig.modelName,
            language: xomDropdownListConfig.sitecoreLanguage,
            value: this.value,
            dependents: dependentsArr
        }
        console.log(obj);


        $.ajax({
            url: "/api/forms/GetHiddenFieldValue",
            type: "post",
            data: obj,
            contenttype: "application/json",
            dataType: "json",
            success: function (response) {
                var jsonResponse = response;
                jsonResponse.forEach(js => {
                    var assignField = document.querySelectorAll('[data-sc-field-name=' + js.fName + ']');
                    console.log(assignField);
                    assignField.forEach(assign => {
                        console.log(assign.getAttribute("id"));
                        var formId = assign.getAttribute("id").includes(idVal);
                        console.log(formId);
                        if (formId) {
                            assign.setAttribute("value", js.fValue);
                        }
                    });
                })
            },
            failure: function (errmsg) {
                alert(errmsg);
            }
        })

    });
});